export const splitMessage = (message: string) => {
  const split = message
    ?.trim()
    ?.replace('\n =', '\n=')
    ?.split('\n=')
    ?.map((part) => part?.replace('=', '')?.trim())

  const [
    name,
    product,
    payment,
    address,
    province,
    zipcode,
    phone,
    facebook,
    sellerName,
    channel,
    dateResult,
  ] = split

  const addressClearNewLine = address.replaceAll(/\n/g, ' ')
  let regex = /^(.+?)(ต\.|ตำบล|แขวง)(.+?)\s*,\s*(อ\.|อำเภอ|เขต)(.+)$/
  let match = addressClearNewLine?.match(regex) ?? []

  const splitAddress = match.slice(1)

  const subDistrict = splitAddress?.[2]?.trim() ?? ''
  const district = splitAddress?.[4]?.trim() ?? ''

  return {
    name,
    product,
    payment,
    address,
    province: province?.trim(),
    subDistrict,
    district,
    zipcode,
    phone,
  }
}

export const replaceMessage = (
  message: string,
  errorMessage: string,
  replace: string,
) => {
  const splits = splitMessage(message)
  let find = ''
  switch (errorMessage) {
    case 'district not found':
      find = splits?.['district'] ?? ''
      break
    case 'sub district not found':
      find = splits?.['subDistrict'] ?? ''
      break
    case 'province not found':
      find = splits?.['province'] ?? ''
      break
    case 'zipcode is invalid':
      find = splits?.['zipcode'] ?? ''
      break
  }
  if (find) {
    return message.replace(find, replace)
  }
  return message
}
